module.exports = __webpack_public_path__ + "media/the-factory-bloc.e8f313be.mp3";